import { render, staticRenderFns } from "./VHoursToday.vue?vue&type=template&id=5f2e01e4&"
import script from "./VHoursToday.vue?vue&type=script&lang=js&"
export * from "./VHoursToday.vue?vue&type=script&lang=js&"
import style0 from "./VHoursToday.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports